module.exports = __webpack_public_path__ + "static/media/34k.6378ce3e.webp";